import {
  GET_SUB_ONE_CATEGORY_BEGIN,
  GET_SUB_ONE_CATEGORY_SUCCESS,
  GET_SUB_ONE_CATEGORY_FAIL
} from '../action/subonecategoryAction'

const initialState = {
  loading: false,
  subonecategorys: null,
  error: null,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_SUB_ONE_CATEGORY_BEGIN:
      return {
        loading: true,
        error: null
      }
    case GET_SUB_ONE_CATEGORY_SUCCESS:
      return {
        loading: false,
        subonecategorys: action.payload.data
      }
    case GET_SUB_ONE_CATEGORY_FAIL:
      return {
        loading: false,
        error: action.payload.data
      }
    default:
      return state
  }
}